const BookingDropCause = {
    CUSTOMER_REQUEST: "customer-request",
    OTHER: "other",
};

export default BookingDropCause;
